var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5625,
    cy: 12,
    r: 12,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4715 4.89648L6.31445 7.63293V11.7376C6.31445 15.5344 8.94144 19.085 12.4715 19.9469C16.0015 19.085 18.6285 15.5344 18.6285 11.7376V7.63293L12.4715 4.89648ZM12.4715 9.00115C13.4292 9.00115 14.387 9.75368 14.387 10.7114V11.7376C14.7974 11.7376 15.2079 12.1481 15.2079 12.6269V15.0213C15.2079 15.4318 14.7974 15.8423 14.3186 15.8423H10.5559C10.1455 15.8423 9.73501 15.4318 9.73501 14.9529V12.5585C9.73501 12.1481 10.1455 11.7376 10.5559 11.7376V10.7114C10.5559 9.75368 11.5137 9.00115 12.4715 9.00115ZM12.4715 9.82209C11.9242 9.82209 11.4453 10.1641 11.4453 10.7114V11.7376H13.4976V10.7114C13.4976 10.1641 13.0187 9.82209 12.4715 9.82209Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityAlarm);
export default __webpack_public_path__ + "static/media/security_alarm.242f3cbde5cdfd99a6f584369cc11c73.svg";
export { ForwardRef as ReactComponent };